import { isBankDI, isCardDI, isDocumentDI, isInvestorProfileDI } from '@onefootprint/core';
import type { DataIdentifier } from '@onefootprint/request-types/dashboard';

// Exclude document, investor profile, financial, and us tax id DIs, and include seqno if provided
const getRelevantDis = (dis: DataIdentifier[], seqno?: string) => {
  const fields = dis
    .filter(
      di => !isDocumentDI(di) && !isInvestorProfileDI(di) && !isBankDI(di) && !isCardDI(di) && di !== 'id.us_tax_id',
    )
    .map(di => {
      return `${di}${seqno ? `:${seqno}` : ''}` as DataIdentifier;
    });
  return fields;
};

export default getRelevantDis;
